module.exports = __webpack_public_path__ + "img/login-overly-top.8ccd564d.png";